<template>
  <v-card :loading="loading">
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid>
        <v-data-table :items="items" :headers="headers">
          <template #[`item.subscription_order`]="{ item }">
            <a
              :href="
                hasPermission('subscription-orders.update')
                  ? $route(
                      'subscription-orders.update',
                      item.subscription_order.id
                    )
                  : $route(
                      'subscription-orders.detail',
                      item.subscription_order.id
                    )
              "
            >
              <strong>{{ item.subscription_order.code }}</strong>
            </a>
            <v-chip
              v-if="item.subscription_order.is_trial"
              color="warning"
              small
              class="mx-1"
            >
              Trial
            </v-chip>
          </template>
          <template #[`item.current_class_date`]="{ item }">
            {{ formatDate(item.current_class_date, 'DD MMM YYYY') }}
          </template>
          <template #[`item.current_class_session`]="{ item }">
            {{ item.current_class_session }} / {{ item.total_class_session }}
          </template>
          <template #[`item.current_invoice`]="{ item }">
            <div v-if="item.current_invoice" class="d-flex align-center">
              <a
                :href="
                  hasPermission('invoices.update')
                    ? $route('invoices.update', item.current_invoice.id)
                    : $route('invoices.detail', item.current_invoice.id)
                "
              >
                <strong>{{ item.current_invoice.code }}</strong>
              </a>
              <v-chip
                :color="
                  invoiceStatusProps(item.current_invoice.status, 'color')
                "
                small
                class="mx-1"
                dark
              >
                <strong>
                  {{ invoiceStatusProps(item.current_invoice.status, 'text') }}
                </strong>
              </v-chip>
            </div>
            <v-btn
              v-else
              depressed
              small
              color="primary"
              :href="
                $route('invoices.create', {
                  subscription_order_id: item.subscription_order.id,
                  issue_date: item.current_class_date,
                  due_date: $moment(item.current_class_date)
                    .endOf('month')
                    .format('YYYY-MM-DD'),
                })
              "
              target="_blank"
              >Create Invoice</v-btn
            >
          </template>
          <template #[`item.last_invoice`]="{ item }">
            <div v-if="item.last_invoice" class="d-flex align-center">
              <a
                :href="
                  hasPermission('invoices.update')
                    ? $route('invoices.update', item.last_invoice.id)
                    : $route('invoices.detail', item.last_invoice.id)
                "
              >
                <strong>{{ item.last_invoice.code }}</strong>
              </a>
              <v-chip
                :color="invoiceStatusProps(item.last_invoice.status, 'color')"
                small
                class="mx-1"
                dark
              >
                <strong>
                  {{ invoiceStatusProps(item.last_invoice.status, 'text') }}
                </strong>
              </v-chip>
            </div>
            <v-btn
              v-else
              depressed
              small
              color="primary"
              :href="
                $route('invoices.create', {
                  subscription_order_id: item.subscription_order.id,
                  issue_date: $moment(item.current_class_date)
                    .subtract(1, 'month')
                    .format('YYYY-MM-DD'),
                  due_date: $moment(item.current_class_date)
                    .subtract(1, 'month')
                    .endOf('month')
                    .format('YYYY-MM-DD'),
                })
              "
              >Create Invoice</v-btn
            >
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'FollowUps',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'Student', value: 'student_name', sortable: false },
        { text: 'Class', value: 'classroom_name', sortable: false },
        { text: 'Teacher', value: 'teacher_name', sortable: false },
        { text: 'Class Date', value: 'current_class_date' },
        {
          text: 'Session',
          value: 'current_class_session',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Month',
          value: 'current_class_month',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Term',
          value: 'current_class_term',
          sortable: false,
          align: 'center',
        },
        { text: 'Order No.', value: 'subscription_order', sortable: false },
        {
          text: 'This Month Invoice',
          value: 'current_invoice',
          sortable: false,
        },
        {
          text: 'Last Month Invoice',
          value: 'last_invoice',
          sortable: false,
        },
      ],
    }
  },
}
</script>
